import { createRouter, RouterProvider } from '@tanstack/react-router';

import { AppPageNotFound } from '../components/AppPageNotFound';
import { getRunsInFip } from '../helpers/getRunsInFip';
import { AccessDeniedPage } from '../pages/AccessDeniedPage/AccessDeniedPage';
import { accessDeniedRoute } from '../pages/AccessDeniedPage/route';
import { homeRoute } from '../pages/HomePage/route';
import { loginRoute } from '../pages/LoginPage/route';
import { authPidCallbackRoute } from '../pages/PidCallbackPage/route';
import { profileRoute } from '../pages/ProfilePage/route';
import { versionRoute } from '../pages/VersionPage/route';
import { clientRoutes } from '../pages/client/routes';
import { fipCallbackRoute } from '../pages/fip/FipCallbackPage/route';
import { fipRoutes } from '../pages/fip/routes';
import { accountSearchResultRoute } from '../pages/search/AccountSearchResultPage/route';
import { advancedSearchResultRoute } from '../pages/search/AdvancedSearchResultPage/route';
import { simpleSearchResultRoute } from '../pages/search/SimpleSearchResultPage/route';
import { serviceSettingsRoutes } from '../pages/serviceSettings/routes';

import { rootRoute } from './routes/rootRoute';
import { valhallaRedirectRoute } from './routes/valhallaRedirectRoute';

const routeTree = rootRoute.addChildren([
	valhallaRedirectRoute,
	versionRoute,
	homeRoute,
	loginRoute,
	accessDeniedRoute,
	accountSearchResultRoute,
	advancedSearchResultRoute,
	simpleSearchResultRoute,
	clientRoutes,
	serviceSettingsRoutes,
	authPidCallbackRoute,
	fipCallbackRoute,
	fipRoutes,
	profileRoute,
]);

const runsInFip = getRunsInFip();

const defaultNotFoundComponent = runsInFip ? (
	<AccessDeniedPage />
) : (
	<AppPageNotFound />
);

export const router = createRouter({
	routeTree,
	basepath: '/',
	defaultPreload: 'intent',
	defaultNotFoundComponent: () => defaultNotFoundComponent,
});

export const AppRouterProvider = () => {
	return <RouterProvider router={router} />;
};

declare module '@tanstack/react-router' {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface Register {
		router: typeof router;
	}

	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface StaticDataRouteOption {
		disableAuthGuard?: boolean;
		documentTitle?: string;
	}
}
